import React from 'react'
import './index.css'
import { MdOutlineSearch } from "react-icons/md";

export default function SearchBar({ placeholder = 'Search', onKeyDown }) {

  const handleKeyDown = (e) => {
    if (typeof onKeyDown === "function") {
      const c = document.getElementById("search-input");
      onKeyDown(e, c.value);
    }
  }

  return (
    <div className='search-layout'>
      <div className="search-icon">
        <MdOutlineSearch style={{
          lineHeight: '40px',
          fontSize: '25px'
        }} />
      </div>
      <input
        id="search-input"
        placeholder={placeholder}
        onKeyDown={handleKeyDown}
      />
    </div>
  )
}
